import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRegistros, getRegistrosResumoMes, getFuncionariosResumo, createRegistro, updateRegistro, deleteRegistro, getSaldoHora, saveSaldoHora, updateSaldoHora, deleteSaldoHora, getJornadas, updateJornada, getSaldosHora } from '../services/api';

const STATUS_OPTS = [
  { value:'NORMAL',   label:'Normal' },
  { value:'FALTA',    label:'Falta' },
  { value:'ATESTADO', label:'Atestado Médico' },
  { value:'FOLGA',    label:'Folga' },
  { value:'FERIAS',   label:'Férias' },
  { value:'FERIADO',  label:'Feriado' },
];

const hoje = () => new Date().toISOString().slice(0,10);
const primeiroDiaMes = () => { const d=new Date(); d.setDate(1); return d.toISOString().slice(0,10); };
const isoToBR = iso => { if(!iso||!iso.includes('-')) return iso; const[y,m,d]=iso.split('-'); return `${d}/${m}/${y}`; };
const brToISO = br => { if(!br||!br.includes('/')) return br; const[d,m,y]=br.split('/'); return `${y}-${m}-${d}`; };

const decToHHMM = v => {
  if (v == null) return '—';
  const neg = v < 0;
  const abs = Math.abs(v);
  const h = Math.floor(abs);
  const m = Math.round((abs - h) * 60);
  return `${neg?'-':''}${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}`;
};

const FORM0 = { funcionario:'', data:hoje(), hora_entrada:'', hora_saida_almoco:'', hora_retorno_almoco:'', hora_saida:'', hora_entrada3:'', hora_saida3:'', hora_entrada4:'', hora_saida4:'', status:'NORMAL', observacao:'' };

export default function RegistroPonto() {
  const navigate = useNavigate();
  const [lista, setLista] = useState([]);
  const [funcs, setFuncs] = useState([]);
  const [filtros, setFiltros] = useState({ funcionario:'', data:hoje(), status:'' });
  const [form, setForm] = useState(FORM0);
  const [editId, setEditId] = useState(null);
  const [modal, setModal] = useState(false);
  const [calModal, setCalModal] = useState(false);
  const [calMes, setCalMes] = useState(() => { const d = new Date(); return { mes: d.getMonth() + 1, ano: d.getFullYear() }; });
  const [calDias, setCalDias] = useState({});
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [saldoModal, setSaldoModal] = useState(false);
  const [saldoReg, setSaldoReg] = useState(null);
  const [saldoForm, setSaldoForm] = useState(null);
  const [saldoId, setSaldoId] = useState(null);
  const [jornadaAjuste, setJornadaAjuste] = useState(null);
  const [ajusteHoras, setAjusteHoras] = useState('');
  const [ajusteHistorico, setAjusteHistorico] = useState(null); // {horas, dataHora}
  const [saldoRecord, setSaldoRecord] = useState(null);
  const [compPorData, setCompPorData] = useState({}); // { 'YYYY-MM-DD': totalMinutos }


  useEffect(() => { getFuncionariosResumo().then(r=>setFuncs(r.data)); }, []);
  useEffect(() => { carregar(); }, [filtros]); // eslint-disable-line

  // Carrega compensações aprovadas e mapeia por data
  useEffect(() => {
    getSaldosHora({ tipo: 'COMPENSAR_DEPOIS', page_size: 500 }).then(r => {
      const registros = r.data.results || r.data;
      const mapa = {};
      registros.forEach(s => {
        if (s.autorizado !== true) return;
        const funcId = s.registro_funcionario_id;
        (s.compensacoes || []).forEach(c => {
          if (!c.data || !funcId) return;
          const key = `${funcId}|${c.data}`;
          mapa[key] = (mapa[key] || 0) + (parseInt(c.minutos) || 0);
        });
      });
      setCompPorData(mapa);
    }).catch(() => {});
  }, []);

  // Define data padrão: último dia anterior a hoje com registros
  useEffect(() => {
    (async () => {
      try {
        const r = await getRegistros({ page_size: 200 });
        const regs = r.data.results || r.data;
        const hojeISO = hoje();
        const datas = regs
          .map(reg => { const [d, m, y] = reg.data.split('/'); return `${y}-${m}-${d}`; })
          .filter(iso => iso < hojeISO)
          .sort().reverse();
        if (datas.length > 0) setFiltros(f => ({ ...f, data: datas[0] }));
      } catch {}
    })();
  }, []); // eslint-disable-line

  const buscarCalendario = useCallback(async (mes, ano) => {
    const r = await getRegistrosResumoMes({ mes, ano });
    setCalDias(r.data.dias || {});
  }, []);

  useEffect(() => { if (calModal) buscarCalendario(calMes.mes, calMes.ano); }, [calModal, calMes, buscarCalendario]);

  const carregar = async () => {
    setLoading(true);
    try { const r = await getRegistros({...filtros, data_inicio:isoToBR(filtros.data), data_fim:isoToBR(filtros.data)}); setLista(r.data.results||r.data); }
    finally { setLoading(false); }
  };

  const abrir = (reg=null) => {
    if (reg) {
      const p=reg.data.split('/');
      setForm({ funcionario:reg.funcionario, data:`${p[2]}-${p[1]}-${p[0]}`, hora_entrada:reg.hora_entrada||'', hora_saida_almoco:reg.hora_saida_almoco||'', hora_retorno_almoco:reg.hora_retorno_almoco||'', hora_saida:reg.hora_saida||'', hora_entrada3:reg.hora_entrada3||'', hora_saida3:reg.hora_saida3||'', hora_entrada4:reg.hora_entrada4||'', hora_saida4:reg.hora_saida4||'', status:reg.status, observacao:reg.observacao||'' });
      setEditId(reg.id);
    } else { setForm({...FORM0, funcionario:filtros.funcionario||''}); setEditId(null); }
    setErro(''); setModal(true);
  };

  const salvar = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const d = { ...form, data:isoToBR(form.data), hora_entrada:form.hora_entrada||null, hora_saida_almoco:form.hora_saida_almoco||null, hora_retorno_almoco:form.hora_retorno_almoco||null, hora_saida:form.hora_saida||null, hora_entrada3:form.hora_entrada3||null, hora_saida3:form.hora_saida3||null, hora_entrada4:form.hora_entrada4||null, hora_saida4:form.hora_saida4||null };
      editId ? await updateRegistro(editId,d) : await createRegistro(d);
      setModal(false); carregar();
    } catch(e) { setErro(JSON.stringify(e.response?.data||'Erro')); }
    finally { setLoading(false); }
  };

  const excluir = async (id) => { if(!window.confirm('Excluir?')) return; await deleteRegistro(id); carregar(); };

  const abrirSaldo = async (reg) => {
    setSaldoReg(reg);
    setSaldoId(null);
    setSaldoRecord(null);
    const positivo = reg.saldo_horas != null && reg.saldo_horas > 0;
    const defaultTipo = positivo ? 'HORA_EXTRA' : 'ABONO';
    setSaldoForm({ tipo: defaultTipo, autorizado: false, data_referencia: '', compensacoes: [], observacao: '', abonado_por: '' });
    try {
      const r = await getSaldoHora(reg.id);
      const existing = (r.data.results || r.data)[0];
      if (existing) {
        setSaldoId(existing.id);
        setSaldoRecord(existing);
        // extrai valor de carga do observacao se existir
        const obs = existing.observacao || '';
        const cargaMatch = obs.match(/^\[CARGA:(\d{2}:\d{2})\]\s*/);
        const cargaHoras = cargaMatch ? cargaMatch[1] : null;
        let obsRest = cargaMatch ? obs.replace(cargaMatch[0], '') : obs;
        const abonoMatch = obsRest.match(/^\[ABONADO_POR:([^\]]+)\]\s*/);
        const abonadoPor = abonoMatch ? abonoMatch[1] : '';
        const obsLimpa = abonoMatch ? obsRest.replace(abonoMatch[0], '') : obsRest;
        setSaldoForm({
          tipo: existing.tipo,
          autorizado: existing.autorizado || false,
          data_referencia: existing.data_referencia ? brToISO(existing.data_referencia) : '',
          compensacoes: (existing.compensacoes && existing.compensacoes.length) ? existing.compensacoes : (existing.tipo === 'COMPENSAR_DEPOIS' ? [{ data: '', minutos: Math.min(Math.abs(Math.round(reg.saldo_horas * 60)), 60) }] : []),
          observacao: obsLimpa,
          abonado_por: abonadoPor,
        });
        if (existing.tipo === 'AJUSTE_JORNADA') {
          if (cargaHoras) {
            setAjusteHoras(cargaHoras);
            setAjusteHistorico({ horas: cargaHoras });
          }
          carregarJornada(reg);
        }
      }
    } catch(_) {}
    setSaldoModal(true);
  };

  const salvarSaldo = async () => {
    // armazena valor de horas no observacao para exibir histórico
    let obsBase = saldoForm.observacao;
    if (saldoForm.tipo === 'AJUSTE_JORNADA' && ajusteHoras)
      obsBase = `[CARGA:${ajusteHoras}] ${obsBase}`.trim();
    if (saldoForm.tipo === 'ABONO' && saldoForm.abonado_por)
      obsBase = `[ABONADO_POR:${saldoForm.abonado_por.trim()}] ${obsBase}`.trim();
    const payload = {
      registro: saldoReg.id,
      tipo: saldoForm.tipo,
      autorizado: saldoForm.tipo === 'HORA_EXTRA' ? saldoForm.autorizado : null,
      data_referencia: saldoForm.tipo === 'COMPENSACAO' && saldoForm.data_referencia ? isoToBR(saldoForm.data_referencia) : null,
      compensacoes: saldoForm.tipo === 'COMPENSAR_DEPOIS' ? saldoForm.compensacoes : [],
      observacao: obsBase,
    };
    try {
      if (saldoForm.tipo === 'AJUSTE_JORNADA') {
        const jResp = await getJornadas({ funcionario: saldoReg.funcionario, ativo: 'true' });
        const jornada = (jResp.data.results || jResp.data)[0];
        if (jornada) {
          const jId = jornadaAjuste?.id || jornada.id;
          const sigla = jornadaAjuste?.sigla || getSigla(saldoReg.data);
          const horarios = { ...(jornada.horarios_dias || {}) };
          const existingH = horarios[sigla] || {};
          let carga = 0;
          if (ajusteHoras) {
            const [h, m] = ajusteHoras.split(':').map(Number);
            carga = h + m / 60;
          }
          horarios[sigla] = { ...existingH, carga_diaria: carga };
          await updateJornada(jId, { ...jornada, horarios_dias: horarios });
        }
      }
      if (saldoId) await updateSaldoHora(saldoId, payload);
      else await saveSaldoHora(payload);
      setSaldoModal(false);
      carregar();
    } catch(e) { alert(JSON.stringify(e.response?.data || 'Erro ao salvar')); }
  };

  const addCompensacao = () => {
    setSaldoForm(f => {
      const saldoMin = saldoReg ? Math.abs(Math.round(saldoReg.saldo_horas * 60)) : 0;
      const usado = f.compensacoes.reduce((s, c) => s + (parseInt(c.minutos) || 0), 0);
      const restante = Math.max(0, saldoMin - usado);
      if (restante <= 0) return f;
      return { ...f, compensacoes: [...f.compensacoes, { data: '', minutos: Math.min(restante, 60) }] };
    });
  };
  const removeCompensacao = (i) => {
    setSaldoForm(f => {
      const next = f.compensacoes.filter((_, idx) => idx !== i);
      return { ...f, compensacoes: next.length ? next : [{ data: '', minutos: 60 }] };
    });
  };
  const updateCompensacao = (i, field, value) => {
    setSaldoForm(f => {
      const list = [...f.compensacoes];
      list[i] = { ...list[i], [field]: value };
      return { ...f, compensacoes: list };
    });
  };
  const isSexta = (isoDate) => { if(!isoDate) return true; return new Date(isoDate+'T00:00:00').getDay() === 5; };

  const SIGLA_DIA = ['DOM','SEG','TER','QUA','QUI','SEX','SAB'];
  const getSigla = (dataBR) => {
    if (!dataBR) return null;
    const [d,m,y] = dataBR.split('/');
    return SIGLA_DIA[new Date(`${y}-${m}-${d}T00:00:00`).getDay()];
  };

  const carregarJornada = async (reg) => {
    setJornadaAjuste(null);
    setAjusteHoras('');
    setAjusteHistorico(null);
    try {
      const r = await getJornadas({ funcionario: reg.funcionario, ativo: true });
      const jornada = (r.data.results || r.data)[0];
      if (!jornada) return;
      const sigla = getSigla(reg.data);
      const horario = (jornada.horarios_dias || {})[sigla] || {};
      setJornadaAjuste({ id: jornada.id, sigla });
      let horasStr = '';
      if (horario.carga_diaria != null) {
        const h = Math.floor(horario.carga_diaria);
        const m = Math.round((horario.carga_diaria - h) * 60);
        horasStr = `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}`;
      } else if (horario.entrada && horario.saida) {
        const [eh,em] = horario.entrada.split(':').map(Number);
        const [sh,sm] = horario.saida.split(':').map(Number);
        let total = (sh*60+sm) - (eh*60+em);
        if (horario.inicio_almoco && horario.fim_almoco) {
          const [iah,iam] = horario.inicio_almoco.split(':').map(Number);
          const [fah,fam] = horario.fim_almoco.split(':').map(Number);
          total -= (fah*60+fam) - (iah*60+iam);
        }
        if (total > 0) {
          const h = Math.floor(total/60), mx = total%60;
          horasStr = `${String(h).padStart(2,'0')}:${String(mx).padStart(2,'0')}`;
        }
      }
      setAjusteHoras(horasStr);
      if (horasStr) setAjusteHistorico({ horas: horasStr });
    } catch(_) {}
  };

  const mudarTipoSaldo = async (tipo) => {
    setSaldoForm(f => ({
      ...f, tipo,
      compensacoes: tipo === 'COMPENSAR_DEPOIS' && !f.compensacoes.length ? [{ data: '', minutos: Math.min(saldoReg ? Math.abs(Math.round(saldoReg.saldo_horas * 60)) : 60, 60) }] : f.compensacoes,
    }));
    if (tipo === 'AJUSTE_JORNADA' && saldoReg) carregarJornada(saldoReg);
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 16, marginBottom: 20, borderBottom: '1px solid #f1f5f9' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ width: 38, height: 38, background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--primary)', fontSize: '1rem', marginRight: 14, flexShrink: 0 }}>
            <i className="bi bi-fingerprint" />
          </div>
          <div>
            <div style={{ fontSize: '0.62rem', fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 3 }}>Gestão de Pessoal · Controle de Ponto</div>
            <div style={{ fontSize: '1.3rem', fontWeight: 700, color: '#334155', letterSpacing: '-0.5px', lineHeight: 1.2 }}>Registro de Ponto</div>
          </div>
        </div>
        <button className="btn-primary-custom" onClick={()=>abrir()} disabled><i className="bi bi-plus-lg"/>Novo</button>
      </div>

      <div className="filter-bar">
        <div style={{minWidth:150}}>
          <label className="form-label">Data</label>
          <div style={{display:'flex',gap:4}}>
            <input type="date" className="form-control" value={filtros.data} onChange={e=>setFiltros({...filtros,data:e.target.value})}/>
            <button
              type="button"
              style={{background:'none',border:'1px solid #bfdbfe',borderRadius:6,padding:'4px 8px',cursor:'pointer',color:'#1d4ed8',whiteSpace:'nowrap'}}
              title="Abrir calendário de registros"
              onClick={() => {
                const d = filtros.data ? new Date(filtros.data+'T00:00:00') : new Date();
                setCalMes({ mes: d.getMonth()+1, ano: d.getFullYear() });
                setCalModal(true);
              }}
            >
              <i className="bi bi-calendar3"/>
            </button>
          </div>
        </div>
        <div style={{minWidth:120}}>
          <label className="form-label">Status</label>
          <select className="form-select" value={filtros.status} onChange={e=>setFiltros({...filtros,status:e.target.value})}>
            <option value="">Todos</option>{STATUS_OPTS.map(s=><option key={s.value} value={s.value}>{s.label}</option>)}
          </select>
        </div>
        <div style={{alignSelf:'flex-end', display:'flex', gap:6}}>
          <button style={{display:'inline-flex',alignItems:'center',gap:4,background:'#eff6ff',border:'1px solid #bfdbfe',borderRadius:6,padding:'3px 9px',cursor:'pointer',color:'#1d4ed8',fontSize:'0.72rem',fontWeight:600}} onClick={() => {
            const iso = filtros.data;
            const [y, m] = iso ? iso.split('-') : [new Date().getFullYear(), new Date().getMonth()+1];
            navigate('/ponto-individual', { state: { funcionarioId: filtros.funcionario || null, mes: Number(m), ano: Number(y) } });
          }}>
            <i className="bi bi-eye"/>Ver
          </button>
        </div>
      </div>

      <div className="card-ponto p-0">
        <div style={{overflowX:'auto'}}>
          <table className="table-ponto" style={{width:'100%', fontSize:'0.65rem', tableLayout:'fixed'}}>
            <colgroup>
              <col style={{width:300}}/>
              {[...Array(8)].map((_,i)=><col key={i} style={{width:58}}/>)}
              <col style={{width:64}}/>
              <col style={{width:64}}/>
              <col style={{width:70}}/>
              <col style={{width:84}}/>
              <col style={{width:150}}/>
              <col style={{width:88}}/>
            </colgroup>
            <thead>
              <tr>
                <th style={{paddingLeft:32}}>Funcionário</th>
                <th style={{textAlign:'center',color:'#16a34a'}}>Ent. 1</th>
                <th style={{textAlign:'center',color:'#dc2626'}}>Saí. 1</th>
                <th style={{textAlign:'center',color:'#16a34a'}}>Ent. 2</th>
                <th style={{textAlign:'center',color:'#dc2626'}}>Saí. 2</th>
                <th style={{textAlign:'center',color:'#16a34a'}}>Ent. 3</th>
                <th style={{textAlign:'center',color:'#dc2626'}}>Saí. 3</th>
                <th style={{textAlign:'center',color:'#16a34a'}}>Ent. 4</th>
                <th style={{textAlign:'center',color:'#dc2626'}}>Saí. 4</th>
                <th style={{textAlign:'center',color:'#1d4ed8'}}>Trab.</th>
                <th style={{textAlign:'center',color:'#0891b2'}} title="Horas de compensação aprovadas para este dia">Comp.</th>
                <th style={{textAlign:'center',color:'#7c3aed'}}>Extra</th>
                <th style={{textAlign:'center',color:'#64748b'}} title="Realizado − Previsto">Saldo</th>
                <th>Status</th>
                <th style={{textAlign:'center'}}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={15} className="text-center py-3"><span className="spinner-border spinner-border-sm text-primary"/></td></tr>}
              {!loading && lista.map((r,i)=>(
                <tr key={r.id} style={{background: i%2===0 ? '#fff' : '#f8fafc'}}>
                  <td style={{paddingLeft:32, fontWeight:600, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>
                    {r.funcionario_nome}
                    {(() => {
                      const toMin = t => { if(!t) return null; const[h,m]=t.split(':').map(Number); return h*60+m; };
                      const s1 = toMin(r.hora_saida_almoco);
                      const e2 = toMin(r.hora_retorno_almoco);
                      if (s1 && e2 && (e2 - s1) < 60) {
                        return <i className="bi bi-exclamation-triangle-fill" title={`Intervalo menor que 1h (${e2-s1}min)`} style={{fontSize:'0.65rem',color:'#f59e0b',marginLeft:4}}/>;
                      }
                      return null;
                    })()}
                  </td>
                  {[
                    r.hora_entrada, r.hora_saida_almoco,
                    r.hora_retorno_almoco, r.hora_saida,
                    r.hora_entrada3, r.hora_saida3,
                    r.hora_entrada4, r.hora_saida4,
                  ].map((h,idx)=>(
                    <td key={idx} style={{textAlign:'center', fontVariantNumeric:'tabular-nums', color: h ? '#1e293b' : '#cbd5e1'}}>
                      {h ? h.slice(0,5) : '—'}
                    </td>
                  ))}
                  <td style={{textAlign:'center', fontWeight:700, color:'#1d4ed8', fontVariantNumeric:'tabular-nums'}}>
                    {r.horas_trabalhadas!=null ? decToHHMM(r.horas_trabalhadas) : '—'}
                  </td>
                  <td style={{textAlign:'center'}}>
                    {(() => {
                      const iso = brToISO(r.data);
                      const mins = compPorData[`${r.funcionario}|${iso}`];
                      if (!mins) return <span style={{color:'#cbd5e1'}}>—</span>;
                      return <span style={{background:'#e0f2fe', color:'#0369a1', borderRadius:3, padding:'1px 6px', fontSize:'0.65rem', fontWeight:700}}>{decToHHMM(mins/60)}</span>;
                    })()}
                  </td>
                  <td style={{textAlign:'center'}}>
                    {r.horas_extras!=null && r.horas_extras!==0
                      ? <span style={{background:r.horas_extras>0?'#f3e8ff':'#fee2e2', color:r.horas_extras>0?'#6b21a8':'#991b1b', borderRadius:3, padding:'1px 6px', fontSize:'0.65rem', fontWeight:700}}>
                          {r.horas_extras>0?'+':''}{decToHHMM(r.horas_extras)}
                        </span>
                      : '—'}
                  </td>
                  <td style={{textAlign:'center'}}>
                    {r.saldo_horas!=null && Math.round(Math.abs(r.saldo_horas)*60) <= 10 ? (
                      <i className="bi bi-check-circle-fill" title="Dentro da tolerância (±10 min)" style={{fontSize:'0.72rem',color:'#16a34a'}}/>
                    ) : r.saldo_horas!=null && Math.round(Math.abs(r.saldo_horas)*60) > 10 ? (
                      <span onClick={()=>abrirSaldo(r)}
                        title={r.saldo_tipo ? `Classificado: ${r.saldo_tipo.replace('_',' ')} — clique para editar` : 'Clique para classificar o saldo'}
                        style={{background:r.saldo_horas>0?'#dcfce7':'#fee2e2', color:r.saldo_horas>0?'#166534':'#991b1b', borderRadius:3, padding:'1px 6px', fontSize:'0.65rem', fontWeight:700, cursor:'pointer', outline:r.saldo_tipo?'2px solid '+(r.saldo_horas>0?'#16a34a':'#dc2626'):'none', outlineOffset:1, display:'inline-flex', alignItems:'center', gap:3}}>
                        {r.saldo_horas>0?'+':''}{decToHHMM(r.saldo_horas)}
                        {r.saldo_tipo && <i className="bi bi-check2" style={{fontSize:'0.6rem'}}/>}
                      </span>
                    ) : '—'}
                  </td>
                  <td><span className={`badge-status badge-status-${r.status}`}>{r.status_display}</span></td>
                  <td style={{textAlign:'center'}}>
                    <button style={{background:'none',border:'1px solid #bfdbfe',borderRadius:6,padding:'3px 6px',cursor:'pointer',color:'#1d4ed8',fontSize:'0.65rem',marginRight:5}} onClick={()=>abrir(r)}><i className="bi bi-pencil"/></button>
                    <button style={{background:'none',border:'1px solid #fecaca',borderRadius:6,padding:'3px 6px',cursor:'pointer',color:'#dc2626',fontSize:'0.65rem'}} onClick={()=>excluir(r.id)}><i className="bi bi-trash"/></button>
                  </td>
                </tr>
              ))}
              {!loading && lista.length===0 && <tr><td colSpan={15}><div className="empty-state"><i className="bi bi-fingerprint"/><p>Nenhum registro encontrado</p></div></td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {modal && (
        <div className="modal-backdrop-custom" onClick={e=>e.target===e.currentTarget&&setModal(false)}>
          <div className="modal-box" style={{maxWidth:620}}>
            <div className="modal-header-custom">
              <h5><i className="bi bi-fingerprint me-2"/>{editId?'Editar Registro':'Novo Registro de Ponto'}</h5>
              <button className="modal-close" onClick={()=>setModal(false)}><i className="bi bi-x-lg"/></button>
            </div>
            <form onSubmit={salvar}>
              <div className="modal-body-custom">
                {erro && <div style={{background:'#fef2f2',border:'1px solid #fecaca',borderRadius:4,padding:'8px 12px',color:'#991b1b',fontSize:'var(--fs-xs)',marginBottom:12}}>{erro}</div>}
                <div className="row g-2">
                  <div className="col-md-8">
                    <label className="form-label">Funcionário *</label>
                    <select className="form-select" required value={form.funcionario} onChange={e=>setForm({...form,funcionario:e.target.value})}>
                      <option value="">Selecione...</option>{funcs.map(f=><option key={f.id} value={f.id}>{f.matricula} — {f.nome}</option>)}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Data *</label>
                    <input type="date" className="form-control" required value={form.data} onChange={e=>setForm({...form,data:e.target.value})}/>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Status</label>
                    <select className="form-select" value={form.status} onChange={e=>setForm({...form,status:e.target.value})}>
                      {STATUS_OPTS.map(s=><option key={s.value} value={s.value}>{s.label}</option>)}
                    </select>
                  </div>
                  <div className="col-12">
                    <label className="form-label">Horários</label>
                    <div style={{background:'var(--gray-50)',border:'1px solid var(--border)',borderRadius:4,padding:'10px 12px'}}>
                      <div className="row g-2 mb-1">
                        <div className="col-3"><label className="form-label">Ent.1</label><input type="time" className="form-control" value={form.hora_entrada} onChange={e=>setForm({...form,hora_entrada:e.target.value})}/></div>
                        <div className="col-3"><label className="form-label">Sai.1</label><input type="time" className="form-control" value={form.hora_saida_almoco} onChange={e=>setForm({...form,hora_saida_almoco:e.target.value})}/></div>
                        <div className="col-3"><label className="form-label">Ent.2</label><input type="time" className="form-control" value={form.hora_retorno_almoco} onChange={e=>setForm({...form,hora_retorno_almoco:e.target.value})}/></div>
                        <div className="col-3"><label className="form-label">Sai.2</label><input type="time" className="form-control" value={form.hora_saida} onChange={e=>setForm({...form,hora_saida:e.target.value})}/></div>
                      </div>
                      <div className="row g-2">
                        <div className="col-3"><label className="form-label">Ent.3</label><input type="time" className="form-control" value={form.hora_entrada3} onChange={e=>setForm({...form,hora_entrada3:e.target.value})}/></div>
                        <div className="col-3"><label className="form-label">Sai.3</label><input type="time" className="form-control" value={form.hora_saida3} onChange={e=>setForm({...form,hora_saida3:e.target.value})}/></div>
                        <div className="col-3"><label className="form-label">Ent.4</label><input type="time" className="form-control" value={form.hora_entrada4} onChange={e=>setForm({...form,hora_entrada4:e.target.value})}/></div>
                        <div className="col-3"><label className="form-label">Sai.4</label><input type="time" className="form-control" value={form.hora_saida4} onChange={e=>setForm({...form,hora_saida4:e.target.value})}/></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12"><label className="form-label">Observação</label><textarea className="form-control" rows={2} value={form.observacao} onChange={e=>setForm({...form,observacao:e.target.value})}/></div>
                </div>
              </div>
              <div className="modal-footer-custom">
                <button type="button" style={{display:'inline-flex',alignItems:'center',gap:4,background:'#f8fafc',border:'1px solid #e2e8f0',borderRadius:6,padding:'6px 14px',cursor:'pointer',color:'#475569',fontSize:'0.8rem',fontWeight:600}} onClick={()=>setModal(false)}>Cancelar</button>
                <button type="submit" className="btn-primary-custom" disabled={loading}>
                  {loading?<span className="spinner-border spinner-border-sm"/>:<><i className="bi bi-check-lg"/>Salvar</>}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Modal Saldo de Horas ── */}
      {saldoModal && saldoReg && saldoForm && (() => {
        const positivo = saldoReg.saldo_horas > 0;
        const minSaldo = Math.abs(Math.round(saldoReg.saldo_horas * 60));
        const totalComp = saldoForm.compensacoes.reduce((s, c) => s + (!c.nao_realizado ? (parseInt(c.minutos) || 0) : 0), 0);
        const compOk = !positivo ? totalComp <= minSaldo : true;
        const TIPO_POS = [
          { value: 'HORA_EXTRA',    label: 'Hora Extra',        icon: 'bi-clock-history' },
          { value: 'COMPENSACAO',   label: 'Compensação',       icon: 'bi-arrow-left-right' },
          { value: 'AJUSTE_JORNADA', label: 'Ajuste de Jornada', icon: 'bi-pencil-square' },
        ];
        const TIPO_NEG = [
          { value: 'ABONO',            label: 'Abono',             icon: 'bi-shield-check' },
          { value: 'AJUSTE_JORNADA',   label: 'Ajuste de Jornada', icon: 'bi-pencil-square' },
          { value: 'COMPENSAR_DEPOIS', label: 'Compensar depois',  icon: 'bi-calendar-plus' },
        ];
        const tipos = positivo ? TIPO_POS : TIPO_NEG;

        return (
          <div className="modal-backdrop-custom" onClick={e => e.target === e.currentTarget && setSaldoModal(false)}>
            <div className="modal-box" style={{maxWidth:520}}>
              <div className="modal-header-custom" style={{background: positivo ? 'linear-gradient(135deg,#14532d,#16a34a)' : 'linear-gradient(135deg,#7f1d1d,#dc2626)'}}>
                <div>
                  <h5 style={{color:'#fff',margin:0}}>
                    <i className={`bi ${positivo ? 'bi-graph-up-arrow' : 'bi-graph-down-arrow'} me-2`}/>
                    {positivo ? 'Saldo Positivo' : 'Saldo Negativo'}
                  </h5>
                  <div style={{fontSize:'0.75rem',color:'rgba(255,255,255,0.8)',marginTop:3}}>
                    {saldoReg.funcionario_nome} — {saldoReg.data} &nbsp;|&nbsp;
                    <strong style={{color:'#fff'}}>{saldoReg.saldo_horas > 0 ? '+' : ''}{decToHHMM(saldoReg.saldo_horas)}</strong>
                  </div>
                </div>
                <button className="modal-close" style={{color:'#fff'}} onClick={() => setSaldoModal(false)}><i className="bi bi-x-lg"/></button>
              </div>

              <div className="modal-body-custom">
                {/* Seleção de tipo */}
                <div style={{marginBottom:16}}>
                  <label className="form-label" style={{fontWeight:600}}>Classificação</label>
                  <div style={{display:'flex',gap:8}}>
                    {tipos.map(t => (
                      <button
                        key={t.value}
                        type="button"
                        onClick={() => mudarTipoSaldo(t.value)}
                        style={{
                          flex:1, padding:'10px 8px', borderRadius:8, border:'2px solid',
                          borderColor: saldoForm.tipo === t.value ? (positivo ? '#16a34a' : '#dc2626') : '#e2e8f0',
                          background: saldoForm.tipo === t.value ? (positivo ? '#f0fdf4' : '#fef2f2') : '#f8fafc',
                          color: saldoForm.tipo === t.value ? (positivo ? '#14532d' : '#7f1d1d') : '#64748b',
                          cursor:'pointer', fontWeight:600, fontSize:'0.8rem', display:'flex', flexDirection:'column', alignItems:'center', gap:4,
                        }}
                      >
                        <i className={`bi ${t.icon}`} style={{fontSize:'1.2rem'}}/>
                        {t.label}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Hora Extra: autorizado? */}
                {saldoForm.tipo === 'HORA_EXTRA' && (
                  <div style={{background:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:8,padding:'12px 14px',marginBottom:12}}>
                    <label style={{display:'flex',alignItems:'center',gap:10,cursor:'pointer',fontWeight:600,color:'#14532d'}}>
                      <input
                        type="checkbox"
                        style={{width:18,height:18,accentColor:'#16a34a'}}
                        checked={saldoForm.autorizado}
                        onChange={e => setSaldoForm(f => ({...f, autorizado: e.target.checked}))}
                      />
                      Hora extra autorizada
                    </label>
                    {!saldoForm.autorizado && (
                      <div style={{marginTop:8,fontSize:'0.72rem',color:'#92400e',display:'flex',alignItems:'center',gap:6}}>
                        <i className="bi bi-exclamation-triangle-fill"/>
                        Hora extra não autorizada — sujeita a não pagamento
                      </div>
                    )}
                  </div>
                )}

                {/* Compensação positiva: data de referência */}
                {/* Abono: quem abonou + justificativa */}
                {saldoForm.tipo === 'ABONO' && (
                  <div style={{background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,padding:'12px 14px',marginBottom:12,display:'flex',flexDirection:'column',gap:10}}>
                    <div>
                      <label className="form-label" style={{fontWeight:600,color:'#7f1d1d',marginBottom:4,display:'flex',alignItems:'center',gap:5}}>
                        <i className="bi bi-person-check-fill"/>Abonado por <span style={{color:'#dc2626'}}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Nome de quem autorizou o abono"
                        value={saldoForm.abonado_por}
                        onChange={e => setSaldoForm(f => ({...f, abonado_por: e.target.value}))}
                        style={{borderColor: !saldoForm.abonado_por?.trim() ? '#fca5a5' : undefined}}
                      />
                      {!saldoForm.abonado_por?.trim() && (
                        <div style={{fontSize:'0.68rem',color:'#dc2626',marginTop:3,display:'flex',alignItems:'center',gap:4}}>
                          <i className="bi bi-exclamation-circle-fill"/>Campo obrigatório
                        </div>
                      )}
                    </div>
                    <div>
                      <label className="form-label" style={{fontWeight:600,color:'#7f1d1d',marginBottom:4,display:'flex',alignItems:'center',gap:5}}>
                        <i className="bi bi-chat-left-text-fill"/>Justificativa <span style={{color:'#dc2626'}}>*</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={2}
                        placeholder="Motivo do abono"
                        value={saldoForm.observacao}
                        onChange={e => setSaldoForm(f => ({...f, observacao: e.target.value}))}
                        style={{borderColor: !saldoForm.observacao?.trim() ? '#fca5a5' : undefined}}
                      />
                      {!saldoForm.observacao?.trim() && (
                        <div style={{fontSize:'0.68rem',color:'#dc2626',marginTop:3,display:'flex',alignItems:'center',gap:4}}>
                          <i className="bi bi-exclamation-circle-fill"/>Campo obrigatório
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {saldoForm.tipo === 'COMPENSACAO' && (
                  <div style={{marginBottom:12}}>
                    <label className="form-label">Data que será compensada</label>
                    <input
                      type="date"
                      className="form-control"
                      value={saldoForm.data_referencia}
                      onChange={e => setSaldoForm(f => ({...f, data_referencia: e.target.value}))}
                    />
                    <div style={{fontSize:'0.7rem',color:'#64748b',marginTop:4}}>
                      Informe a data de ausência que esta hora compensa.
                    </div>
                  </div>
                )}

                {/* Ajuste de Jornada: editar horário do dia */}
                {saldoForm.tipo === 'AJUSTE_JORNADA' && (
                  <div style={{marginBottom:12}}>
                    {/* Histórico do ajuste anterior */}
                    {saldoRecord && saldoRecord.tipo === 'AJUSTE_JORNADA' && (() => {
                      const rawDt = saldoRecord.atualizado_em || saldoRecord.criado_em;
                      const dt = rawDt ? new Date(rawDt) : null;
                      const dtFmt = dt && !isNaN(dt)
                        ? dt.toLocaleString('pt-BR', {day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'})
                        : '—';
                      const horasAnt = ajusteHistorico?.horas || '—';
                      return (
                        <div style={{background:'#fafafa',border:'1px solid #e2e8f0',borderRadius:8,padding:'8px 12px',marginBottom:10,display:'flex',alignItems:'center',justifyContent:'space-between',gap:10,fontSize:'0.7rem',color:'#475569'}}>
                          <div style={{display:'flex',alignItems:'center',gap:10}}>
                            <i className="bi bi-clock-history" style={{color:'#6366f1',fontSize:'0.9rem'}}/>
                            <div>
                              <div style={{fontWeight:700,color:'#1e293b',marginBottom:2}}>Ajuste registrado em {dtFmt}</div>
                              <div>Jornada definida: <strong style={{color:'#1d4ed8'}}>{horasAnt}</strong></div>
                            </div>
                          </div>
                          <button
                            type="button"
                            title="Remover ajuste"
                            onClick={async () => {
                              if (!window.confirm('Remover o ajuste de jornada?')) return;
                              await deleteSaldoHora(saldoRecord.id);
                              setSaldoRecord(null); setSaldoId(null); setAjusteHistorico(null);
                              setSaldoModal(false); carregar();
                            }}
                            style={{background:'none',border:'1px solid #fecaca',borderRadius:6,color:'#dc2626',cursor:'pointer',padding:'4px 8px',fontSize:'0.72rem',whiteSpace:'nowrap'}}
                          >
                            <i className="bi bi-trash me-1"/>Remover
                          </button>
                        </div>
                      );
                    })()}
                    <div style={{background:'#eff6ff',border:'1px solid #bfdbfe',borderRadius:8,padding:'12px 14px'}}>
                      <div style={{fontSize:'0.72rem',color:'#1d4ed8',fontWeight:700,marginBottom:10,display:'flex',alignItems:'center',gap:6}}>
                        <i className="bi bi-info-circle-fill"/>
                        Nova jornada de <strong>{jornadaAjuste?.sigla || getSigla(saldoReg.data) || '—'}</strong> — {saldoReg.data}
                        {!jornadaAjuste && <span style={{color:'#94a3b8',fontWeight:400,fontSize:'0.68rem'}}>(carregando...)</span>}
                      </div>
                      <div style={{display:'flex',alignItems:'flex-end',gap:12}}>
                        <div style={{flex:1}}>
                          <label className="form-label" style={{fontSize:'0.72rem',fontWeight:600}}>Horas a trabalhar neste dia</label>
                          <input
                            type="time"
                            className="form-control"
                            value={ajusteHoras}
                            onChange={e => setAjusteHoras(e.target.value)}
                            placeholder="00:00"
                          />
                          <div style={{fontSize:'0.65rem',color:'#64748b',marginTop:3}}>
                            Use 00:00 para dia sem jornada (folga / zerado)
                          </div>
                        </div>
                        <button
                          type="button"
                          style={{background:'none',border:'1px solid #e2e8f0',borderRadius:6,padding:'6px 10px',fontSize:'0.72rem',color:'#64748b',cursor:'pointer',marginBottom:22}}
                          title="Zerar — dia sem jornada"
                          onClick={() => setAjusteHoras('00:00')}
                        >
                          <i className="bi bi-x-circle me-1"/>Zerar
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Compensar depois: lista de datas/horários */}
                {saldoForm.tipo === 'COMPENSAR_DEPOIS' && (
                  <div style={{marginBottom:12}}>
                    <div style={{marginBottom:12}}>
                      <label className="form-label" style={{margin:0,fontWeight:600,marginBottom:8,display:'block'}}>Datas de compensação</label>
                      {(() => {
                        const pct = minSaldo > 0 ? Math.min(100, Math.round(totalComp / minSaldo * 100)) : 0;
                        const completo = totalComp >= minSaldo;
                        const restante = Math.max(0, minSaldo - totalComp);
                        const barColor = completo ? '#16a34a' : totalComp > 0 ? '#f59e0b' : '#e2e8f0';
                        return (
                          <div style={{background:'#f8fafc',border:'1px solid #e2e8f0',borderRadius:10,padding:'12px 14px'}}>
                            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-end',marginBottom:10}}>
                              <div>
                                <div style={{fontSize:'0.6rem',fontWeight:700,color:'#94a3b8',textTransform:'uppercase',letterSpacing:'0.06em',marginBottom:2}}>Compensado</div>
                                <div style={{display:'flex',alignItems:'baseline',gap:5}}>
                                  <span style={{fontSize:'1.25rem',fontWeight:800,color: completo ? '#16a34a' : totalComp > 0 ? '#f59e0b' : '#64748b',lineHeight:1}}>{decToHHMM(totalComp/60)}</span>
                                  <span style={{fontSize:'0.72rem',color:'#94a3b8',fontWeight:500}}>de {decToHHMM(minSaldo/60)}</span>
                                </div>
                              </div>
                              <div style={{textAlign:'right'}}>
                                {completo ? (
                                  <span style={{background:'#dcfce7',color:'#16a34a',borderRadius:20,padding:'3px 10px',fontSize:'0.68rem',fontWeight:700,display:'flex',alignItems:'center',gap:4}}>
                                    <i className="bi bi-check-circle-fill"/>Completo
                                  </span>
                                ) : (
                                  <div>
                                    <div style={{fontSize:'0.6rem',fontWeight:700,color:'#94a3b8',textTransform:'uppercase',letterSpacing:'0.06em',marginBottom:2}}>Restante</div>
                                    <span style={{fontSize:'1rem',fontWeight:800,color:'#dc2626'}}>{decToHHMM(restante/60)}</span>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div style={{background:'#e2e8f0',borderRadius:99,height:6,overflow:'hidden'}}>
                              <div style={{width:`${pct}%`,height:'100%',borderRadius:99,background: completo ? 'linear-gradient(90deg,#16a34a,#4ade80)' : 'linear-gradient(90deg,#f59e0b,#fbbf24)',transition:'width 0.3s ease'}}/>
                            </div>
                            <div style={{textAlign:'right',fontSize:'0.62rem',color:'#94a3b8',marginTop:4,fontWeight:600}}>{pct}%</div>
                          </div>
                        );
                      })()}
                    </div>

                    {saldoForm.compensacoes.map((c, i) => {
                      // Entrada anulada (reagendada para outra data)
                      if (c.nao_realizado) {
                        return (
                          <div key={i} style={{display:'flex',gap:8,marginBottom:8,alignItems:'center',opacity:0.6}}>
                            <div style={{flex:1,position:'relative'}}>
                              <input type="date" className="form-control date-picker-visible" value={c.data} readOnly
                                style={{textDecoration:'line-through',background:'#f1f5f9',color:'#94a3b8',cursor:'default'}} />
                            </div>
                            <div style={{width:110}}>
                              <div style={{position:'relative'}}>
                                <input type="number" className="form-control" value={c.minutos} readOnly
                                  style={{textDecoration:'line-through',background:'#f1f5f9',color:'#94a3b8',paddingRight:34,cursor:'default'}} />
                                <span style={{position:'absolute',right:8,top:'50%',transform:'translateY(-50%)',fontSize:'0.65rem',color:'#94a3b8',pointerEvents:'none'}}>min</span>
                              </div>
                            </div>
                            <div style={{width:64,display:'flex',alignItems:'center',flexShrink:0}}>
                              <span style={{background:'#fee2e2',color:'#991b1b',borderRadius:4,padding:'2px 7px',fontSize:'0.62rem',fontWeight:700,whiteSpace:'nowrap',display:'flex',alignItems:'center',gap:3}}>
                                <i className="bi bi-arrow-repeat"/>
                                {c.nova_data ? (() => { const [y,m,d] = c.nova_data.split('-'); return `${d}/${m}`; })() : 'Anulado'}
                              </span>
                            </div>
                          </div>
                        );
                      }
                      // Entrada normal (editável)
                      const isSex = isSexta(c.data);
                      const maxMin = isSex ? 120 : 60;
                      const outrosMin = saldoForm.compensacoes.reduce((s, c2, j) => j !== i && !c2.nao_realizado ? s + (parseInt(c2.minutos) || 0) : s, 0);
                      const maxEfetivo = Math.min(maxMin, Math.max(0, minSaldo - outrosMin));
                      const minsOk = parseInt(c.minutos) <= maxEfetivo;
                      const activeComps = saldoForm.compensacoes.filter(c2 => !c2.nao_realizado);
                      const isLast = i === saldoForm.compensacoes.length - 1 || !saldoForm.compensacoes.slice(i + 1).some(c2 => !c2.nao_realizado);
                      return (
                        <div key={i} style={{display:'flex',gap:8,marginBottom:8,alignItems:'center'}}>
                          <div style={{flex:1}}>
                            <input
                              type="date"
                              className="form-control date-picker-visible"
                              value={c.data}
                              onChange={e => updateCompensacao(i, 'data', e.target.value)}
                              style={isLast && !c.data ? {borderColor:'#f59e0b',boxShadow:'0 0 0 2px rgba(245,158,11,0.15)'} : {}}
                            />
                          </div>
                          <div style={{width:110}}>
                            <div style={{position:'relative'}}>
                              <input
                                type="number"
                                className="form-control"
                                min={1} max={maxMin}
                                style={{borderColor: !minsOk ? '#dc2626' : undefined, paddingRight:34}}
                                value={c.minutos}
                                onChange={e => updateCompensacao(i, 'minutos', e.target.value)}
                              />
                              <span style={{position:'absolute',right:8,top:'50%',transform:'translateY(-50%)',fontSize:'0.65rem',color:'#94a3b8',pointerEvents:'none'}}>min</span>
                            </div>
                            {!minsOk && <div style={{fontSize:'0.65rem',color:'#dc2626',marginTop:2}}>Máx {maxEfetivo} min</div>}
                          </div>
                          <div style={{width:64,display:'flex',gap:4,flexShrink:0}}>
                            <button type="button" onClick={() => removeCompensacao(i)} title="Remover" style={{background:'none',border:'none',color:'#dc2626',cursor:'pointer',padding:'4px 6px',borderRadius:4}}>
                              <i className="bi bi-trash"/>
                            </button>
                            {isLast ? (
                              <button type="button" onClick={addCompensacao} disabled={!c.data || totalComp >= minSaldo} title={!c.data ? 'Informe a data antes de adicionar' : 'Adicionar linha'} style={{background:'none',border:'1px solid',borderColor: (!c.data || totalComp >= minSaldo) ? '#e2e8f0' : '#16a34a',color: (!c.data || totalComp >= minSaldo) ? '#cbd5e1' : '#16a34a',cursor: (!c.data || totalComp >= minSaldo) ? 'not-allowed' : 'pointer',padding:'4px 6px',borderRadius:4}}>
                                <i className="bi bi-plus-lg"/>
                              </button>
                            ) : (
                              <span style={{width:30}}/>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Observação — oculto no Abono pois já tem Justificativa */}
                {saldoForm.tipo !== 'ABONO' && (
                  <div>
                    <label className="form-label">Observação</label>
                    <textarea
                      className="form-control"
                      rows={2}
                      value={saldoForm.observacao}
                      onChange={e => setSaldoForm(f => ({...f, observacao: e.target.value}))}
                      placeholder="Opcional..."
                    />
                  </div>
                )}
              </div>

              <div className="modal-footer-custom" style={{justifyContent:'space-between'}}>
                <div style={{display:'flex',gap:8}}>
                  <button type="button" style={{display:'inline-flex',alignItems:'center',gap:4,background:'#f8fafc',border:'1px solid #e2e8f0',borderRadius:6,padding:'6px 14px',cursor:'pointer',color:'#475569',fontSize:'0.8rem',fontWeight:600}} onClick={() => setSaldoModal(false)}>Cancelar</button>
                  {saldoId && (
                    <button
                      type="button"
                      style={{display:'inline-flex',alignItems:'center',gap:5,background:'none',border:'1px solid #fecaca',borderRadius:6,padding:'6px 12px',cursor:'pointer',color:'#dc2626',fontSize:'0.8rem',fontWeight:600}}
                      onClick={async () => {
                        if (!window.confirm('Remover a classificação deste saldo?')) return;
                        await deleteSaldoHora(saldoId);
                        setSaldoModal(false);
                        carregar();
                      }}
                    >
                      <i className="bi bi-trash"/>Remover classificação
                    </button>
                  )}
                </div>
                <button
                  type="button"
                  className="btn-primary-custom"
                  style={{background: positivo ? 'linear-gradient(135deg,#14532d,#16a34a)' : 'linear-gradient(135deg,#7f1d1d,#dc2626)'}}
                  disabled={saldoForm.tipo === 'ABONO' && (!saldoForm.abonado_por?.trim() || !saldoForm.observacao?.trim())}
                  onClick={salvarSaldo}
                >
                  <i className="bi bi-check-lg"/>Salvar
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Modal Calendário de Registros ── */}
      {calModal && (() => {
        const MESES_PT = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
        const DIAS_SEM = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];
        const { mes, ano } = calMes;
        const primeiroDia = new Date(ano, mes - 1, 1).getDay();
        const totalDias   = new Date(ano, mes, 0).getDate();
        const maxCount    = Math.max(1, ...Object.values(calDias));
        const hojeISO     = new Date().toISOString().slice(0, 10);

        const navegarMes = (delta) => {
          let m = mes + delta, a = ano;
          if (m > 12) { m = 1; a++; }
          if (m < 1)  { m = 12; a--; }
          setCalMes({ mes: m, ano: a });
        };

        const selecionarDia = (dia) => {
          const iso = `${ano}-${String(mes).padStart(2,'0')}-${String(dia).padStart(2,'0')}`;
          setFiltros(f => ({ ...f, data: iso }));
          setCalModal(false);
        };

        const cells = [];
        for (let i = 0; i < primeiroDia; i++) cells.push(null);
        for (let d = 1; d <= totalDias; d++) cells.push(d);

        const isoSel = filtros.data;

        const btnNav = {
          background: '#f8fafc', border: '1px solid #e2e8f0',
          color: '#475569', fontSize: '0.75rem', cursor: 'pointer',
          width: 30, height: 30, borderRadius: 7,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'background 0.12s',
        };

        return (
          <div className="modal-backdrop-custom" onClick={e => e.target === e.currentTarget && setCalModal(false)}>
            <div style={{ background: '#fff', borderRadius: 14, boxShadow: '0 4px 32px rgba(15,23,42,0.13)', width: 440, overflow: 'hidden', border: '1px solid #e2e8f0' }}>

              {/* Cabeçalho */}
              <div style={{ padding: '18px 20px 12px', borderBottom: '1px solid #f1f5f9' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                  <button onClick={() => navegarMes(-1)} style={btnNav}><i className="bi bi-chevron-left" /></button>
                  <div style={{ textAlign: 'center' }}>
                    <span style={{ fontSize: '0.95rem', fontWeight: 600, color: '#0f172a', letterSpacing: '-0.1px' }}>
                      {MESES_PT[mes - 1]}
                    </span>
                    <span style={{ fontSize: '0.82rem', color: '#94a3b8', fontWeight: 400, marginLeft: 7 }}>{ano}</span>
                  </div>
                  <button onClick={() => navegarMes(1)} style={btnNav}><i className="bi bi-chevron-right" /></button>
                </div>
                {/* Legenda */}
                <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
                  {[
                    { dot: '#2563eb', label: 'Com registros' },
                    { dot: '#e2e8f0', label: 'Sem registros' },
                    { dot: 'transparent', label: 'Hoje', ring: '#f59e0b' },
                  ].map(({ dot, label, ring }) => (
                    <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: '0.65rem', color: '#64748b' }}>
                      <div style={{ width: 8, height: 8, borderRadius: '50%', background: dot, border: ring ? `2px solid ${ring}` : 'none', flexShrink: 0 }} />
                      {label}
                    </div>
                  ))}
                </div>
              </div>

              {/* Dias da semana */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', padding: '9px 14px 4px', background: '#fafafa', borderBottom: '1px solid #f1f5f9' }}>
                {DIAS_SEM.map((d, i) => (
                  <div key={d} style={{ textAlign: 'center', fontSize: '0.58rem', fontWeight: 700, color: i === 0 ? '#fca5a5' : '#9ca3af', letterSpacing: '0.6px' }}>
                    {d.toUpperCase()}
                  </div>
                ))}
              </div>

              {/* Células */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2, padding: '8px 10px 10px' }}>
                {cells.map((dia, i) => {
                  if (!dia) return <div key={`e${i}`} style={{ height: 52 }} />;
                  const iso    = `${ano}-${String(mes).padStart(2,'0')}-${String(dia).padStart(2,'0')}`;
                  const count  = calDias[iso] || 0;
                  const isSel  = iso === isoSel;
                  const isHoje = iso === hojeISO;
                  const ratio  = count > 0 ? count / maxCount : 0;

                  let dotColor;
                  if      (ratio >= 0.75) dotColor = '#1e40af';
                  else if (ratio >= 0.4)  dotColor = '#2563eb';
                  else if (ratio >= 0.15) dotColor = '#3b82f6';
                  else                    dotColor = '#60a5fa';

                  return (
                    <div
                      key={dia}
                      onClick={() => selecionarDia(dia)}
                      title={count ? `${count} funcionário(s) com registro` : ''}
                      style={{
                        height: 52, borderRadius: 8, gap: 2,
                        display: 'flex', flexDirection: 'column',
                        alignItems: 'center', justifyContent: 'center',
                        cursor: count > 0 ? 'pointer' : 'default',
                        background: isSel ? '#0f172a' : count > 0 ? '#dbeafe' : 'transparent',
                        border: isHoje && !isSel ? '2px solid #f59e0b' : count > 0 && !isSel ? '1px solid #bfdbfe' : '1px solid transparent',
                        transition: 'background 0.12s',
                      }}
                      onMouseEnter={e => { if (count > 0 && !isSel) e.currentTarget.style.background = '#bfdbfe'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = isSel ? '#0f172a' : count > 0 ? '#dbeafe' : 'transparent'; }}
                    >
                      <span style={{
                        fontSize: '0.85rem', lineHeight: 1,
                        fontWeight: isSel ? 700 : count > 0 ? 600 : 400,
                        color: isSel ? '#fff' : isHoje && !isSel ? '#d97706' : count > 0 ? '#0f172a' : '#d1d5db',
                      }}>
                        {dia}
                      </span>
                      {count > 0 && (
                        <span style={{ fontSize: '0.55rem', fontWeight: 700, lineHeight: 1, color: isSel ? '#93c5fd' : dotColor, display: 'flex', alignItems: 'center', gap: 2, marginTop: 2 }}>
                          <i className="bi bi-people-fill" style={{ fontSize: '0.5rem' }} />{count}
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Rodapé */}
              <div style={{ borderTop: '1px solid #f1f5f9', padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <button
                  style={{ background: 'none', border: 'none', fontSize: '0.7rem', color: '#64748b', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5, fontWeight: 500 }}
                  onClick={() => { const d = new Date(); setCalMes({ mes: d.getMonth()+1, ano: d.getFullYear() }); }}
                >
                  <i className="bi bi-calendar3" style={{ color: '#2563eb', fontSize: '0.72rem' }} />Ir para hoje
                </button>
                <button
                  style={{ background: '#0f172a', color: '#fff', border: 'none', borderRadius: 7, padding: '6px 18px', fontSize: '0.72rem', fontWeight: 600, cursor: 'pointer' }}
                  onClick={() => setCalModal(false)}
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        );
      })()}

    </div>
  );
}
